import { render } from "./BasicColumnDashboard.vue?vue&type=template&id=7ef1985a"
import script from "./BasicColumnDashboard.vue?vue&type=script&lang=js"
export * from "./BasicColumnDashboard.vue?vue&type=script&lang=js"
script.render = render

export default script